import Error from 'next/error'

function FourOhFour() {
    return <Error statusCode={404} />
}

export default FourOhFour;
